// extracted by mini-css-extract-plugin
export default {"calendarBox":"Attendance_calendarBox__1gSRg"};